import React from 'react';
import DTICalculator from './DTICalculator.js';

var DTICalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$annualIncome = attrs.annualIncome,
      annualIncome = _attrs$annualIncome === void 0 ? 7000 : _attrs$annualIncome,
      _attrs$minCreditCardP = attrs.minCreditCardPayments,
      minCreditCardPayments = _attrs$minCreditCardP === void 0 ? 200 : _attrs$minCreditCardP,
      _attrs$carLoanPayment = attrs.carLoanPayments,
      carLoanPayments = _attrs$carLoanPayment === void 0 ? 50 : _attrs$carLoanPayment,
      _attrs$studentLoanPay = attrs.studentLoanPayments,
      studentLoanPayments = _attrs$studentLoanPay === void 0 ? 300 : _attrs$studentLoanPay,
      _attrs$alimonySupport = attrs.alimonySupportPayments,
      alimonySupportPayments = _attrs$alimonySupport === void 0 ? 0 : _attrs$alimonySupport,
      _attrs$secondaryHomeE = attrs.secondaryHomeExpenses,
      secondaryHomeExpenses = _attrs$secondaryHomeE === void 0 ? 0 : _attrs$secondaryHomeE,
      _attrs$otherDebtPayme = attrs.otherDebtPayments,
      otherDebtPayments = _attrs$otherDebtPayme === void 0 ? 0 : _attrs$otherDebtPayme;
    var defaultValues = {
      annualIncome: annualIncome,
      minCreditCardPayments: minCreditCardPayments,
      carLoanPayments: carLoanPayments,
      studentLoanPayments: studentLoanPayments,
      alimonySupportPayments: alimonySupportPayments,
      secondaryHomeExpenses: secondaryHomeExpenses,
      otherDebtPayments: otherDebtPayments
    };
    return /*#__PURE__*/React.createElement(DTICalculator, {
      defaultValues: defaultValues
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/dti-calculator',
    title: 'DTI calculator',
    description: 'DTI calculator',
    icon: 'businessperson',
    keywords: ['mortgages', 'calculators', 'debt', 'income'],
    category: 'Calculators',
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      annualIncome: {
        type: 'number',
        label: 'Annual income',
        default: 7000,
        control: 'number'
      },
      minCreditCardPayments: {
        type: 'number',
        label: 'Min. credit card payments',
        default: 200,
        control: 'number'
      },
      carLoanPayments: {
        type: 'number',
        label: 'Car loan payments',
        default: 50,
        control: 'number'
      },
      studentLoanPayments: {
        type: 'number',
        label: 'Student loan payments',
        default: 300,
        control: 'number'
      },
      alimonySupportPayments: {
        type: 'number',
        label: 'Alimony/child support payments',
        default: 0,
        control: 'number'
      },
      secondaryHomeExpenses: {
        type: 'number',
        label: 'Secondary home expenses',
        default: 0,
        control: 'number'
      },
      otherDebtPayments: {
        type: 'number',
        label: 'Other loan or debt payments',
        default: 0,
        control: 'number'
      }
    }
  }
};
var DTICalculatorBlock$1 = DTICalculatorBlock;

export { DTICalculatorBlock$1 as default };
